
import { Vue, Options, prop } from "vue-class-component";
import { RevenueDashboardState } from "@/domain/entities/RevenueDashboard";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import { formatPriceRP } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
  data = prop<RevenueDashboardState>({
    default: () => new RevenueDashboardState()
  });
}

@Options({
  components: {
    Skeleton
  }
})
export default class TotalRevenueSection extends Vue.with(Props) {
  get formattedMainRevenue() {
    return this.formatIDRCurrency(this.data.overviewData.overview.totalRevenue);
  }

  get formattedCompareRevenue() {
    return this.formatIDRCurrency(
      this.data.overviewData.comparison.totalRevenue
    );
  }

  get isCompareRevenueZero() {
    return this.data.overviewData.comparison.totalRevenue === 0;
  }

  get formattedGrowthPercentage() {
    return this.data.overviewData.totalRevenueDifferencePercentage;
  }

  get formattedMainStt() {
    return Intl.NumberFormat("id-ID").format(
      this.data.overviewData.overview.totalStt
    );
  }

  get formattedCompareStt() {
    return Intl.NumberFormat("id-ID").format(
      this.data.overviewData.comparison.totalStt
    );
  }

  get isCompareSttZero() {
    return this.data.overviewData.comparison.totalStt === 0;
  }

  get formattedSttGrowthPercentage() {
    return this.data.overviewData.totalSttDifferencePercentage;
  }

  get errorOverview() {
    return this.data.errorOverview;
  }

  get accountCurrency() {
    return (AccountController.accountData.accountCurrency as "IDR" | "MYR") ?? "IDR";
  }

  formatIDRCurrency(value = 0) {
    return formatPriceRP(value, this.accountCurrency);
  }
}
